import React, { memo } from 'react';
import { differenceInMinutes } from 'date-fns';
import { sentenceCase } from './agendaDay';
import { NARROW_LANE, blockLabel, blockLines, blockName, textOn, withAlpha } from './weekGrid';

// Bloco de um agendamento na Semana: um botão na posição do horário, que abre o "Detalhes do agendamento". Fundo na cor
// do status, como no calendário, com o texto preto ou branco pelo contraste. Mostra o que cabe pela duração; o nome
// acessível é o texto inteiro do cartão da Lista. top e height em px; col e cols: lado a lado no encaixe
const WeekBlock = ({ item, kind, top, height, col, cols, laneWidth, doctorName, onOpen }) => {
  const color = item.status?.cor || '#adb5bd';
  const minutes = differenceInMinutes(item.end, item.start);
  const lines = blockLines(minutes);
  const width = laneWidth / cols;
  const style = {
    top,
    height,
    left: `calc(${(col / cols) * 100}% + 2px)`,
    width: `calc(${100 / cols}% - 4px)`,
    '--agenda-status': color,
  };
  if (kind === 'block') style['--agenda-status-stripe'] = withAlpha(color, 0.3);
  if (kind === 'appointment') style['--agenda-status-text'] = textOn(color);

  return (
    <button
      type='button'
      className={`agenda-week-block is-${kind}`}
      style={style}
      aria-label={blockLabel(item, kind, doctorName)}
      data-id={item.id}
      onClick={() => onOpen(item)}
    >
      <span className='agenda-week-block-name'>{kind === 'block' ? 'Bloqueio' : blockName(item.paciente?.nome, width < NARROW_LANE)}</span>
      {lines.time ? <span>{width < 80 && kind !== 'block' ? item.hora_inicial : `${item.hora_inicial}–${item.hora_final}`}</span> : ''}
      {lines.type && kind !== 'block' ? <span>{sentenceCase(item.tipo_atendimento?.descricao)}</span> : ''}
      {lines.progress && kind !== 'block' && item.prontuario?.progresso ? <span>{item.prontuario.progresso}</span> : ''}
    </button>
  );
};

// memo + key = id: a atualização de 30 s não recria os botões, e a rolagem e o foco ficam onde estavam
export default memo(WeekBlock);
